import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LinkBtnComponent } from '@enginuity/core/molecules/tertiary/link-btn.component';
import { PaginationComponent } from '../pagination/pagination.component';
import { FooterInformation } from '@services/ui-services/models/footer-information';
import { DropdownSinglePieceComponent } from '@enginuity/core/molecules/dropdown-single-piece/dropdown-single-piece.component';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';

import { OverlayModule } from '@angular/cdk/overlay';
@Component({
  standalone: true,
  selector: 'app-table-footer',
  templateUrl: './table-footer.component.html',
  styleUrls: ['./table-footer.component.scss'],
  imports: [
    CommonModule,
    CdkMenuTrigger,
    CdkMenu,
    CdkMenuItem,
    OverlayModule,
    LinkBtnComponent,
    PaginationComponent,
    DropdownSinglePieceComponent,
  ],
})
export class TableFooterComponent {
  @Output() onPageChange = new EventEmitter<number>();
  @Output() custom_click = new EventEmitter<any>();
  @Output() onActions = new EventEmitter<object>();

  @Input() pageInfo: FooterInformation = {
    isShowPagination: true,
    currentPage: 0,
    totalPages: 0,
    selectedRows: 0,
    totalRows: 0,
    isShowSelected: true,
    isShowShowing: true,
    showingRowsCount: 0,
    currentRowsCount: 0,
  };

  pageChange(selectedPage: number) {
    this.onPageChange.emit(selectedPage);
  }
  navigateOnKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onActions.emit();
    }
  }
  // customClick(event:string){
  //   this.onActions.emit(action);
  // }
  @Input() footerLinks = [
    {
      label: 'Export',
      active: false,
      IconType: 'download',
      disabled: false,
      alert: false,
      dropdown: [
        {
          label: 'Export',
          icon: 'no_icon',
          color: 'default',
        },
      ],
    },
    {
      label: 'Duplicate',
      active: false,
      IconType: 'jam_files_f',
      disabled: false,
      alert: false,
    },
    {
      label: 'Create a segment',
      active: false,
      IconType: 'add',
      disabled: false,
      alert: false,
    },
    {
      label: 'Add to a segment',
      active: false,
      IconType: 'coupon',
      disabled: false,
      alert: false,
    },
    {
      label: 'Delete',
      active: false,
      IconType: 'jam_trash_alt_f',
      disabled: false,
      alert: true,
    },
  ];
  showDropdown(link: any): boolean {
    return link.dropdown !== undefined && link.dropdown !== null;
  }
}
